module.exports = __webpack_public_path__ + "img/btn-p.8edb988e.png";